import React from 'react';
import Input from '../../../components/Input/Input';
import TextArea from '../../../components/TextArea/TextArea';
import Checkbox from '../../../components/Checkbox/Checkbox';

const OtherPartial = ({ formik }) => {
  return (
    <div className="grid gap-6 grid-cols-1">
      <TextArea
        label="Free Form Content Request"
        id="contentTopic"
        value={formik.values?.contentTopic}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        required
        dataTest="generated-prompt-form-content-topic"
        error={formik.touched?.contentTopic && formik.errors?.contentTopic}
        bottomMarginSizing={1}
      />
      <div className="grid grid-rows-1 grid-cols-form-word-copyscape gap-6 mb-4">
        <div className="row-start-1 row-end-2 col-start-1 col-end-2 w-full max-w-[128px]">
          <Input
            label="Word Count"
            value={formik.values?.wordCount}
            onChange={({ target: { value } }) => {
              formik.setFieldValue('wordCount', value.replace(/[^\d]/, ''));
            }}
            onBlur={formik.handleBlur}
            error={formik.touched?.wordCount && formik.errors?.wordCount}
            id="wordCount"
            maxLength={4}
            required
            dataTest="generated-prompt-form-word-count"
            type="tel"
            max="2500"
            min="100"
            pattern="[0-9]{1,4}"
            disabled
          />
        </div>
        <div className="row-start-1 row-end-2 col-start-2 col-end-3 flex justify-end whitespace-nowrap">
          <Checkbox
            label="Check with Copyscape"
            value={formik.values?.executeCopyscapeSearch}
            onChange={({ target: { checked } }) => {
              formik.setFieldValue('executeCopyscapeSearch', checked);
            }}
            onBlur={formik.handleBlur}
            type="checkbox"
            error={formik.touched?.executeCopyscapeSearch && formik.errors?.executeCopyscapeSearch}
            id="copyscape"
            dataTest="mslp-form-copyscape"
          />
        </div>
      </div>
    </div>
  );
};

export default OtherPartial;
